import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

// Iter 716 (Kamel) — lien en bio mémorisable : /espagne → page Été 2027, visite comptée côté serveur (?s=tiktok…)
export default function GoEspagne() {
  const [params] = useSearchParams();
  useEffect(() => {
    const s = params.get('s') || 'bio';
    const c = params.get('c');
    window.location.replace(`${process.env.REACT_APP_BACKEND_URL}/api/go/espagne?s=${encodeURIComponent(s)}${c ? `&c=${encodeURIComponent(c)}` : ''}`);
  }, [params]);
  return null;
}
